import { useEffect, useState } from "react";
import api from "../api";
import EmailComposer from "../components/EmailComposer";

const EMPTY = { id: null, name: "", subject: "", draft: "", body_html: "", body_text: "" };

export default function EmailTemplates() {
  const [list, setList] = useState([]);
  const [tpl, setTpl] = useState(EMPTY);
  const [improve, setImprove] = useState(true);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [testTo, setTestTo] = useState("");
  const [testName, setTestName] = useState("");
  const [compose, setCompose] = useState(false);
  const [sent, setSent] = useState([]);
  const [linkReport, setLinkReport] = useState(null);
  const [attachment, setAttachment] = useState(null);

  const loadAttachment = () => api.get("/email-templates/attachment", { noCache: true }).then((r) => setAttachment(r.data)).catch(() => {});

  const load = () => api.get("/email-templates").then((r) => setList(r.data)).catch(() => {});
  const loadSent = () => api.get("/emails/sent").then((r) => setSent(r.data)).catch(() => {});
  useEffect(() => { load(); loadSent(); loadAttachment(); }, []);

  const generate = async () => {
    if (!tpl.draft.trim()) { setMsg("Scrivi prima una bozza."); return; }
    setBusy(true); setMsg("Claude sta generando l'email… (può richiedere 1-2 minuti, non chiudere la pagina)");
    try {
      const start = await api.post("/email-templates/generate", { draft: tpl.draft, subject: tpl.subject, improve_text: improve });
      const jobId = start.data.job_id;
      for (let i = 0; i < 120; i++) {
        await new Promise((res) => setTimeout(res, 2500));
        const st = await api.get(`/email-templates/generate/${jobId}`, { noCache: true });
        if (st.data.status === "done") {
          const r = st.data.result;
          setTpl((t) => ({ ...t, subject: r.subject, body_html: r.html, body_text: r.text }));
          setMsg("Email generata. Controlla l'anteprima e salva.");
          setBusy(false);
          return;
        }
        if (st.data.status === "error") throw new Error(st.data.error || "generazione fallita");
      }
      throw new Error("tempo scaduto, riprova");
    } catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); setBusy(false); }
  };

  const save = async () => {
    if (!tpl.name.trim()) { setMsg("Dai un nome al template."); return; }
    const payload = { name: tpl.name, subject: tpl.subject, draft: tpl.draft, body_html: tpl.body_html, body_text: tpl.body_text };
    try {
      const r = tpl.id ? await api.put(`/email-templates/${tpl.id}`, payload) : await api.post("/email-templates", payload);
      setTpl({ ...tpl, id: r.data.id }); load(); setMsg("Template salvato.");
    } catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
  };

  const sendTest = async () => {
    if (!testTo.trim()) { setMsg("Indica un'email per la prova."); return; }
    setMsg("Invio prova…");
    try {
      await api.post("/email-templates/send-test", {
        to: testTo, subject: tpl.subject, body_html: tpl.body_html, body_text: tpl.body_text,
        test_name: testName, base_url: window.location.origin,
      });
      setMsg(`Email di prova inviata a ${testTo} (con nome "${testName || "—"}", link e tracking attivi come in una campagna reale).`);
    } catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
  };

  const open = (t) => setTpl({ ...EMPTY, ...t });
  const remove = async (id) => { if (!window.confirm("Eliminare il template?")) return; await api.delete(`/email-templates/${id}`); if (tpl.id === id) setTpl(EMPTY); load(); };

  return (
    <div>
      <div className="toolbar">
        <div>
          <h1 className="page-title">Template Email</h1>
          <p className="page-sub">Scrivi una bozza, Claude crea l'email HTML professionale e responsive.</p>
        </div>
        <div className="spacer" />
        <button className="btn primary" onClick={() => setCompose(true)} data-testid="compose-new-btn">✉️ Componi nuova email</button>
      </div>

      <div className="grid-2" style={{ alignItems: "start", gap: 18 }}>
        <div className="panel">
          <div className="field"><label>Nome template</label><input value={tpl.name} onChange={(e) => setTpl({ ...tpl, name: e.target.value })} placeholder="es. Promemoria scadenza F24" data-testid="tpl-name" /></div>
          <div className="field"><label>Oggetto (facoltativo, lo propone Claude)</label><input value={tpl.subject} onChange={(e) => setTpl({ ...tpl, subject: e.target.value })} data-testid="tpl-subject" /></div>
          <div className="field"><label>La tua bozza</label>
            <textarea rows={9} value={tpl.draft} onChange={(e) => setTpl({ ...tpl, draft: e.target.value })} placeholder="Scrivi qui il messaggio in modo semplice. Claude lo trasformerà in una email curata." data-testid="tpl-draft" />
          </div>
          <label className="muted" style={{ display: "flex", gap: 8, alignItems: "center", margin: "6px 0" }}>
            <input type="checkbox" checked={improve} onChange={(e) => setImprove(e.target.checked)} /> Claude può migliorare anche il testo (tono, call-to-action)
          </label>
          <div className="toolbar">
            <button className="btn primary" onClick={generate} disabled={busy} data-testid="tpl-generate-btn">{busy ? "Generazione…" : "✨ Genera con Claude"}</button>
            <button className="btn" onClick={save} data-testid="tpl-save-btn">Salva template</button>
            <label className="btn" style={{ cursor: "pointer" }} data-testid="tpl-upload-html-label">
              📄 Carica HTML pronto
              <input type="file" accept=".html,.htm" style={{ display: "none" }} data-testid="tpl-upload-html"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  const rd = new FileReader();
                  rd.onload = async () => {
                    const raw = String(rd.result);
                    try {
                      const r = await api.post("/email-templates/verify-links", { body_html: raw });
                      setTpl((t) => ({ ...t, body_html: r.data.body_html, name: t.name || file.name.replace(/\.html?$/i, "") }));
                      setLinkReport(r.data);
                      const s = r.data.summary;
                      setMsg(`HTML caricato: ${s.totale} link verificati, ${s.corretti} corretti automaticamente${s.da_controllare ? `, ${s.da_controllare} DA CONTROLLARE` : ""}. Imposta nome e oggetto e salva.`);
                    } catch {
                      setTpl((t) => ({ ...t, body_html: raw, name: t.name || file.name.replace(/\.html?$/i, "") }));
                      setLinkReport(null);
                      setMsg("HTML caricato (verifica link non riuscita): controlla l'anteprima e salva.");
                    }
                  };
                  rd.readAsText(file);
                  e.target.value = "";
                }} />
            </label>
            {tpl.id && <button className="btn" onClick={() => setTpl(EMPTY)}>Nuovo</button>}
          </div>
          <div className="toolbar" style={{ marginTop: 6, flexWrap: "wrap" }}>
            <label className="btn" style={{ cursor: "pointer" }} data-testid="tpl-upload-attachment-label">
              📎 Carica file scaricabile
              <input type="file" accept=".xlsx,.xls,.csv,.pdf,.docx" style={{ display: "none" }} data-testid="tpl-upload-attachment"
                onChange={async (e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  const fd = new FormData();
                  fd.append("file", file);
                  try {
                    const r = await api.post("/email-templates/attachment", fd, { headers: { "Content-Type": "multipart/form-data" } });
                    setAttachment(r.data);
                    setMsg(`File "${r.data.filename}" caricato: il link nell'email farà scaricare questo file (con tracciamento).`);
                  } catch (err) { setMsg("Errore caricamento file: " + (err.response?.data?.detail || err.message)); }
                  e.target.value = "";
                }} />
            </label>
            {attachment && (
              <span className="muted" style={{ fontSize: 12 }} data-testid="tpl-attachment-info">
                {attachment.available ? `✓ File collegato al link dell'email: ${attachment.filename}` : `⚠️ Nessun file sul server (atteso: ${attachment.filename})`}
              </span>
            )}
          </div>
          <div className="toolbar" style={{ marginTop: 6 }}>
            <input style={{ maxWidth: 240 }} placeholder="prova@esempio.it" value={testTo} onChange={(e) => setTestTo(e.target.value)} data-testid="tpl-test-to" />
            <input style={{ maxWidth: 160 }} placeholder="Nome per il saluto" value={testName} onChange={(e) => setTestName(e.target.value)} data-testid="tpl-test-name" />
            <button className="btn" onClick={sendTest} data-testid="tpl-sendtest-btn">Invia prova</button>
          </div>
          {msg && <p className="muted" data-testid="tpl-msg" style={{ marginTop: 6 }}>{msg}</p>}
          {linkReport && linkReport.report.length > 0 && (
            <div style={{ marginTop: 8 }} data-testid="tpl-link-report">
              <strong style={{ fontSize: 13 }}>Verifica link ({linkReport.report.length}):</strong>
              {!linkReport.attachment_available && <p style={{ color: "#f87171", fontSize: 12, margin: "4px 0" }}>⚠️ Il file registro-pubblicita.xlsx non è presente sul server: il link di download non funzionerà.</p>}
              <ul style={{ margin: "6px 0 0", paddingLeft: 18, fontSize: 12 }}>
                {linkReport.report.map((l, i) => (
                  <li key={i} style={{ color: l.action === "da_controllare" ? "#f87171" : l.action === "corretto" ? "#fbbf24" : "#6ee7b7", marginBottom: 2 }}>
                    {l.action === "da_controllare" ? "⚠️" : l.action === "corretto" ? "🔧" : "✓"}{" "}
                    <code style={{ wordBreak: "break-all" }}>{l.href || "(vuoto)"}</code> — {l.note}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="panel">
          <h3>Anteprima</h3>
          {tpl.body_html ? (
            <iframe title="anteprima" srcDoc={tpl.body_html} data-testid="tpl-preview" style={{ width: "100%", height: 540, border: "1px solid rgba(255,255,255,.12)", borderRadius: 10, background: "#fff" }} />
          ) : <div className="empty">L'anteprima dell'email apparirà qui dopo la generazione.</div>}
        </div>
      </div>

      <div className="panel" style={{ marginTop: 18 }}>
        <h3>Template salvati</h3>
        <table>
          <thead><tr><th>Nome</th><th>Oggetto</th><th></th></tr></thead>
          <tbody>
            {list.map((t) => (
              <tr key={t.id}>
                <td>{t.name}</td>
                <td className="muted">{t.subject}</td>
                <td style={{ whiteSpace: "nowrap" }}>
                  <button className="btn sm" onClick={() => open(t)}>Apri</button>{" "}
                  <button className="btn sm danger" onClick={() => remove(t.id)}>Elimina</button>
                </td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={3}><div className="empty">Nessun template ancora.</div></td></tr>}
          </tbody>
        </table>
      </div>

      <div className="panel" style={{ marginTop: 18 }} data-testid="sent-history-panel">
        <div className="toolbar">
          <h3 style={{ margin: 0 }}>Storico inviati</h3>
          <div className="spacer" />
          <button className="btn sm" onClick={loadSent} data-testid="sent-refresh-btn">Aggiorna</button>
        </div>
        <table>
          <thead><tr><th>Data</th><th>A</th><th>Oggetto</th><th>Tipo</th></tr></thead>
          <tbody>
            {sent.map((s) => (
              <tr key={s.id} data-testid={`sent-row-${s.id}`}>
                <td className="muted" style={{ whiteSpace: "nowrap" }}>{s.sent_at ? new Date(s.sent_at).toLocaleString("it-IT") : "—"}</td>
                <td>{s.to}</td>
                <td className="muted">{s.subject || "(senza oggetto)"}</td>
                <td><span className="pill">{s.kind || "email"}</span></td>
              </tr>
            ))}
            {sent.length === 0 && <tr><td colSpan={4}><div className="empty">Nessuna email inviata ancora.</div></td></tr>}
          </tbody>
        </table>
      </div>

      {compose && (
        <EmailComposer mode="new" onClose={() => setCompose(false)} onSent={loadSent} />
      )}
    </div>
  );
}
